/*
 *
 *  *
 *  *  Copyright (C) THL A29 Limited, a Tencent company. All rights reserved.
 *  *  SPDX-License-Identifier: Apache-2.0
 *  *
 *
 */

import React, { useEffect } from "react";
import style from "./index.module.scss";
import Between from "@components/ui/Between";
import china from "@imgs/china.png";
export default function WorldNodes({
  onClick,
}: {
  onClick: (value: string) => void;
}) {
  useEffect(() => {}, []);
  return (
    <div className={style.chart}>
      <div className={style.chart_title}>
        <Between
          title="区块链节点"
          content={
            <img width="30px" src={china} onClick={() => onClick("china")} />
          }
        />
      </div>
      <div style={{ height: "425px", width: "842px" }}>
        <iframe
          scrolling="no"
          frameBorder="0"
          style={{
            width: "100%",
            height: "100%",
            overflow: "hidden",
          }}
          src="/world.html"
        />
      </div>
    </div>
  );
}
